module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_fuji-230db14f7f4ba383dbe7e00f7df3d8f9.jpg";